module.exports = __webpack_public_path__ + "media/packs/site/assets/images/fr/fr_section03_title-4103889887f09de2119bf32f3977e6ad.png";